import { Component, HostListener, OnInit } from '@angular/core'
import { AuthService } from '../../../services/auth.services'
import { RestServices } from '../../../services/rest.services'
import { FormBuilder } from '@angular/forms'
import { SharedServices } from '../../../services/shared.services'
import { ModalService } from '../../../services/modal.service'
import { getImageStatusUrl, imageUrl } from '../../../../helper/common'
import { notification } from 'onsenui'

@Component({
    selector: 'app-modal-history',
    templateUrl: './modal-mail-history.component.html',
    styleUrls: ['../../../stagingcss/root-ui-view.component.css', '../../../stagingcss/main-body.component.css', '../../../stagingcss/main-view.component.css', '../../../stagingcss/lui-select.component.css', '../../../stagingcss/image-viewer.component.css'],
})

export class ModalMailHistoryComponent implements OnInit {

    hiddenModalClinicMailHistory = 'hidden'
    en: {}
    getClientMailId: object = null
    imageUrl = imageUrl
    pauseVideo = true
    hostKeyboard: String = 'ModalMailHistoryComponent-hostKeyboard'

    constructor(private authData: AuthService, private restApi: RestServices, private formBuider: FormBuilder, private _sharedService: SharedServices, private modalService: ModalService) {
        this.modalService.changeEmitted$.subscribe(success => {
            if (success) {
                if (success.modal === 'MailHistory') {
                    this.hiddenModalClinicMailHistory = 'active'
                    this.getClientMailId = success
                }
            }
        })
    }

    // hiden modal
    hidenModalClinnicHistoryMail() {
        this.hiddenModalClinicMailHistory = 'hidden'
    }

    ngOnInit() {
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent, ModalMailHistoryComponent: String = 'ModalMailHistoryComponent-hostKeyboard') {
        if (ModalMailHistoryComponent === this.hostKeyboard) {
            const keyPressed = event.keyCode
            if (keyPressed === 27) {
                event.preventDefault()
                this.hidenModalClinnicHistoryMail()
            }
        }
    }

    downloadMovie(i) {
        const tmp = getImageStatusUrl(this.getClientMailId['data']['movie']['id'])
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_get(tmp, tokenReNew).subscribe(res => {
                var xhr = new XMLHttpRequest()
                xhr.open('GET', res['url'], true)
                xhr.responseType = 'blob'
                const _thi = this

                xhr.onprogress = function(event) {
                    if (event.lengthComputable) {
                        var percentComplete = (event.loaded / event.total) * 100
                        // console.log(percentComplete);
                        // console.log(event.loaded);
                    }
                }

                xhr.onload = function(event) {
                    if (this != undefined && this['status'] != undefined && this['status'] == 200) {
                        _thi.saveBlob(this['response'], _thi.getClientMailId['data']['movie']['id'], i)
                    }
                }

                xhr.send()
            })
        })
    }

    saveBlob(response, fileName, index) {
        if (navigator.msSaveBlob) {
            //OK for IE10+
            navigator.msSaveBlob(response, fileName)
        } else {
            this.html5Saver(response, fileName, index)
        }
    }

    changeLanguage() {
        return this.en = this.authData.showLang(true)
    }

    html5Saver(blob, fileName, index) {
        this.changeLanguage()
        var a = document.getElementById('download')
        document.body.appendChild(a)
        var url = window.URL.createObjectURL(blob)
        a.setAttribute('href', url)
        a.setAttribute('download', fileName)
        notification.confirm({
            message: this.en['download-notice'],
            title: `<b>${ this.en['download'] }</b>`,
            buttonLabels: ['OK'],
            callback: i => {
                if (i === 0) {  // here this is not cancelled.  1 is correct.
                    a.click()
                }
            },
        })
    }

    pauseVid(event, pause) {
        const video = event.target
        if (pause) {
            video.play()
            this.pauseVideo = false
        } else {
            video.pause()
            this.pauseVideo = true
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/clinic/modal-mail-history.component.ts